import { ProcedureFormBase } from "./procedure-form.model";


export class ExtendedProcedureFormBase extends ProcedureFormBase {

    serviceName!: string
    serviceState!: number
    formPreview: boolean = false
    formDelete: boolean = false

    static override from(source: ExtendedProcedureForm): ExtendedProcedureFormBase {
        let current = new ExtendedProcedureFormBase()
        Object.assign(current, source)
        return current
    }

}

export interface ExtendedProcedureForm extends ExtendedProcedureFormBase { }